import { createFileRoute, Link } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { FolderOpen, ChevronLeft } from 'lucide-react';
import { PageLoader } from '@/components/shared/PageLoader';

const Assets = lazy(() => import('@/pages/Assets'));

function AssetsDetailRoute() {
  const { assetId } = Route.useParams();
  return (
    <Suspense fallback={<PageLoader />}>
      <Assets assetId={assetId} />
    </Suspense>
  );
}

/** Shown when the route itself resolves to not-found (a thrown notFound()).
 *  The in-library "asset isn't available" dead-end lives in <Assets> — this is
 *  the belt-and-suspenders fallback for a route-level miss. */
function AssetNotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-muted flex items-center justify-center mb-5">
        <FolderOpen className="w-7 h-7 text-muted-foreground" />
      </div>
      <h1 className="text-xl font-semibold text-foreground mb-2">This asset isn&apos;t available</h1>
      <p className="text-muted-foreground text-sm max-w-sm mb-6">
        It may have been moved or removed, or your plan doesn&apos;t include access to it.
      </p>
      <Link
        to="/assets"
        className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-foreground text-background text-sm font-medium hover:opacity-90 transition-opacity"
      >
        <ChevronLeft className="w-4 h-4" />
        Back to library
      </Link>
    </div>
  );
}

export const Route = createFileRoute('/assets/$assetId/')({
  component: AssetsDetailRoute,
  notFoundComponent: AssetNotFound,
});
